class Currency {
    static show() {
        return "₽";
    }
}

export default Currency;